<template>
    <div>
        <!-- Display Archival Collection -->
        <!-- If current object is collection show title -->
        <div class='wrapper' v-if='showCollection'>
            <span v-if='object._index == "archival_collection"' :title='object.searchable.title[0]'>
                {{object.searchable.title[0]}}
            </span>

            <!-- Else If current object has a collection parent show title -->
            <router-link @click.native.stop v-else-if='object.parent_collection' :to="{name: 'object', params: {id: object.parent_collection_id.value}}">
                {{object.parent_collection.value}}
            </router-link>
        </div>


        <!-- Display Archival Series -->
        <!-- If current object is series show title -->
        <div class='wrapper' v-if='showSeries'>
            <!-- Show arrow if a (parent exists) and (this record is a series, has a parent series, or has a child series)-->
            <span v-if='showSeriesArrow'>
                <img class='hierarchy_arrow arrow_indent_1' src='/images/level_arrow.svg'>
            </span>

            <span v-if='object._index == "archival_series"' :title='object.searchable.title[0]'>
                {{object.searchable.title[0]}}
            </span>

            <!-- Else If current object has a series parent show title -->
            <router-link @click.native.stop v-else-if='object.parent_series' :to="{name: 'object', params: {id: object.parent_series_id.value}}">
                {{object.parent_series.value}}
            </router-link>

            <!-- Else If current object has series children show count -->
            <a :href="generateLink({'indices': 'archival_series', 'parent-keyword': object._id}, true)" v-else-if='hasChild("archival_series")'>
                Series ({{object.relation_count.child.archival_series}})
            </a>
        </div>


        <!-- Display Archival File Unit -->
        <!-- If current object is fileunit show title -->
        <div class='wrapper' v-if='showFileUnit'>
            <!-- Show arrow if a (parent exists) and (this record is a fileunit or has a child fileunit)-->
            <span v-if='showFileUnitArrow'>
                <img class='hierarchy_arrow'
                    :class="{'arrow_indent_1': !showSeries, 'arrow_indent_2': showSeries}"
                    src='/images/level_arrow.svg'>
            </span>

            <span v-if='object._index == "archival_fileunit"' :title='object.searchable.title[0]'>
                {{object.searchable.title[0]}}
            </span>

            <!-- Else If current object has a fileunit parent show title -->
            <router-link @click.native.stop v-else-if='object.parent_fileunit' :to="{name: 'object', params: {id: object.parent_fileunit_id.value}}">
                {{object.parent_fileunit.value}}
            </router-link>

            <!-- Else If current object has fileunit children show count -->
            <a :href="generateLink({'indices': 'archival_fileunit', 'parent-keyword': object._id}, true)" v-else-if='hasChild("archival_fileunit")'>
                File Unit ({{object.relation_count.child.archival_fileunit}})
            </a>
        </div>



        <!-- Display Archival Item -->
        <div class='wrapper' v-if='showItem'>
            <!-- Show arrow if a (parent exists) and (this record is a item or has a child item)-->
            <span v-if='showItemArrow'>
                <img class='hierarchy_arrow'
                    :class="{
                        'arrow_indent_1': !showSeries && !showFileUnit,
                        'arrow_indent_2': (!showSeries && showFileUnit) || (showSeries && !showFileUnit),
                        'arrow_indent_3': showSeries && showFileUnit
                    }"
                    src='/images/level_arrow.svg'>
            </span>

            <!-- If current object is item show title -->
            <span v-if='object._index == "archival_item"' :title='object.searchable.title[0]'>
                {{object.searchable.title[0]}}
            </span>

            <!-- Else If current object has item children show count -->
            <a :href="generateLink({'indices': 'archival_item', 'parent-keyword': object._id}, true)" v-else-if='hasChild("archival_item")'>
                Item ({{object.relation_count.child.archival_item}})
            </a>
        </div>
    </div>
</template>

<script>
    import ViewRelated from '../../../mixins/viewRelated.js'
    import ManageProperties from '../../../mixins/manageProperties.js'
    import FilterManager from './../../filterManager.js'
    import EventHub from '../../eventHub.js'

    export default {
        mixins: [ManageProperties, ViewRelated],
        props: ['object', 'property'],
        methods: {
            viewObject: function (id) {
                EventHub.$emit('load-object', id)
            },
            hasChild: function (type) {
                return this.object.relation_count.child && this.object.relation_count.child[type] > 0
            }
        },
        computed: {
            showCollection: function () {
                return this.object._index == "archival_collection" || this.object.parent_collection
            },
            showSeries: function () {
                return this.object._index == "archival_series" || this.object.parent_series || this.hasChild("archival_series")
            },
            showFileUnit: function () {
                return this.object._index == "archival_fileunit" || this.object.parent_fileunit || this.hasChild("archival_fileunit")
            },
            showItem: function () {
                return this.object._index == "archival_item" || this.hasChild("archival_item")
            },
            showSeriesArrow: function () {
                return this.showCollection
            },
            showFileUnitArrow: function () {
                return this.showCollection || this.showSeries
            },
            showItemArrow: function () {
                return this.showCollection || this.showSeries || this.showFileUnit
            }
        }
    };
</script>

<style scoped>
    .wrapper {
        padding-bottom: 5px;
    }

    .arrow_indent_1 {
        margin-left: 20px;
    }

    .arrow_indent_2 {
        margin-left: 40px;
    }

    .arrow_indent_3 {
        margin-left: 60px;
    }
</style>
